import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { Helmet } from "react-helmet";
import { supabase } from "../supabaseClient";
import {
  FaWhatsapp,
  FaShippingFast,
  FaCheckCircle,
  FaHeadset,
  FaStar,
} from "react-icons/fa";

const Home = ({
  productos,
  addToCart,
  toggleFavorite,
  getFavorites,
  searchTerm,
}) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const favoritos = getFavorites();
  const [reseñas, setReseñas] = useState([]);

  useEffect(() => {
    const fetchReseñas = async () => {
      const { data, error } = await supabase
        .from("reviews")
        .select("*")
        .eq("aprobada", true);

      if (error) {
        console.error("Error cargando reseñas:", error);
      } else {
        setReseñas(data);
      }
    };

    fetchReseñas();
  }, []);

  const handleAddFavorite = async (producto) => {
    try {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) {
        toggleFavorite(producto);
        return;
      }

      toggleFavorite(producto);
    } catch (err) {
      console.error("Error al agregar favorito:", err);
    }
  };

  const productosFiltrados = productos.filter((p) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      p.nombre.toLowerCase().includes(term) ||
      p.descripcion.toLowerCase().includes(term)
    );
  });

  const heroHeight =
    window.innerWidth < 480 ? 250 : window.innerWidth < 768 ? 300 : 450;
  const h1Size =
    window.innerWidth < 480 ? 28 : window.innerWidth < 768 ? 32 : 48;
  const pSize =
    window.innerWidth < 480 ? 14 : window.innerWidth < 768 ? 16 : 20;

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {/* ⭐ HERO ⭐ */}
      <div
        className="hero-video"
        style={{
          width: "100%",
          height: `${heroHeight}px`,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <video
          src="/videos/diseño-sin-titulo.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="hero-video"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />
   __      <Helmet>
        <title>Tienda online de cuidado personal y belleza | Esencial</title>

        
      </Helmet>


        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.35)",
            zIndex: 1,
          }}
        ></div>

        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            textAlign: "center",
            color: "white",
            padding: "0 20px",
            maxWidth: "800px",
          }}
        ><h1
  className="hero-title"
  style={{
    fontSize: `${h1Size}px`,
    fontWeight: 700,
    letterSpacing: "1px",
    textTransform: "none",
  }}
>
  Tienda online de cuidado personal y belleza
</h1>

<p
  className="hero-subtitle"
  style={{
    fontSize: `${pSize}px`,
    fontWeight: 300,
    lineHeight: 1.5,
  }}
>
  Descubre cremas faciales hidratantes, productos de cuidado dental y accesorios
  para una rutina de belleza completa.
</p>

        </div>
      </div>

      {/* ⭐ PRODUCTOS ⭐ */}
      <div style={{ overflowX: "auto", padding: "20px" }}>
        <div
          className="product-grid"
          style={{
            display: "inline-flex",
            justifyContent: "center",
            gap: "20px",
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          {productosFiltrados.length > 0 ? (
            productosFiltrados.map((prod, idx) => (
              <ProductCard
                key={idx}
                producto={prod}
                addToCart={addToCart}
                onAddFavorite={() => handleAddFavorite(prod)}
                isFavorite={favoritos.some((f) => f.nombre === prod.nombre)}
              />
            ))
          ) : (
            <p
              style={{
                textAlign: "center",
                width: "100%",
                marginTop: "40px",
                fontSize: "18px",
                color: "#555",
              }}
            >
              No se encontraron productos.
            </p>
          )}
        </div>
      </div>

      {/* ⭐ SERVICIOS ⭐ */}
      <div
        className="features-container"
        style={{
          maxWidth: "1200px",
          margin: "60px auto",
          padding: "40px 20px",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          gap: "40px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <FaShippingFast size={40} color="#4B6CB7" />
          <h3 style={{ fontSize: "22px", fontWeight: "600", marginBottom: "10px" }}>
            Envíos rápidos
          </h3>
          <p style={{ fontSize: "16px", fontWeight: "300", color: "#555" }}>
            Recibe tus productos en tiempo récord.
          </p>
        </div>

        <div style={{ textAlign: "center" }}>
          <FaCheckCircle size={40} color="#4B6CB7" />
          <h3 style={{ fontSize: "22px", fontWeight: "600", marginBottom: "10px" }}>
            Calidad garantizada
          </h3>
          <p style={{ fontSize: "16px", fontWeight: "300", color: "#555" }}>
            Productos seleccionados con el máximo cuidado.
          </p>
        </div>

        <div style={{ textAlign: "center" }}>
          <FaHeadset size={40} color="#4B6CB7" />
          <h3 style={{ fontSize: "22px", fontWeight: "600", marginBottom: "10px" }}>
            Soporte real
          </h3>
          <p style={{ fontSize: "16px", fontWeight: "300", color: "#555" }}>
            Estamos para ayudarte en todo momento.
          </p>
        </div>
      </div>

      {/* ⭐ RESEÑAS ⭐ */}
      <div style={{ backgroundColor: "#F4DDD6", padding: "50px 0" }}>
        <h2
          style={{
            textAlign: "center",
            color: "#333",
            fontSize: "28px",
            fontWeight: "700",
            marginBottom: "30px",
          }}
        >
          Lo que dicen nuestros clientes
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "20px",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {reseñas.length > 0 ? (
            reseñas.map((reseña) => (
              <div
                key={reseña.id}
                className="review-card"
                style={{
                  flex: "1 1 300px",
                  maxWidth: "300px",
                  background: "white",
                  borderRadius: "15px",
                  padding: "20px",
                  textAlign: "center",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <p style={{ fontSize: "16px", color: "#555", marginBottom: "10px" }}>
                  "{reseña.comentario}"
                </p>
                <p
                  style={{
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "10px",
                  }}
                >
                  — {reseña.nombre}
                </p>

                <div style={{ color: "#FFD700" }}>
                  {(() => {
                    const estrellas = Math.max(
                      1,
                      Math.min(5, Number(reseña.rating) || 1)
                    );
                    return [...Array(estrellas)].map((_, i) => (
                      <FaStar key={i} />
                    ));
                  })()}
                </div>
              </div>
            ))
          ) : (
            <p style={{ width: "100%", textAlign: "center", color: "#777" }}>
              Aún no hay reseñas aprobadas.
            </p>
          )}
        </div>

        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <button
            onClick={() => navigate("/add-review")}
            style={{
              background: "linear-gradient(135deg, #4B6CB7, #182848)",
              color: "white",
              border: "none",
              borderRadius: "30px",
              padding: "14px 40px",
              fontSize: "17px",
              fontWeight: "500",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
              transition: "all 0.3s ease",
              letterSpacing: "0.5px",
            }}
          >
            ✨ Dejar una reseña
          </button>
        </div>
      </div>

      {/* ⭐ CONTACTO ⭐ */}
      <div
        style={{
          maxWidth: "600px",
          margin: "60px auto",
          padding: "40px 20px",
          background: "#f2f2f2",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "30px" }}>Contacto</h2>

        <div style={{ marginBottom: "30px" }}>
          <h3>Teléfonos</h3>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              fontSize: "18px",
              flexWrap: "wrap",
            }}
          >
            <a
              href="https://wa.me/34625751451"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "#25D366",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FaWhatsapp size={24} /> 625 751 451
            </a>

            <a
              href="https://wa.me/34606547265"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "#25D366",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FaWhatsapp size={24} /> 606 547 265
            </a>
          </div>
        </div>

        <div>
          <h3>Correo electrónico</h3>

          <a
            href="mailto:esencial@gmail.com"
            style={{
              color: "#4B6CB7",
              textDecoration: "underline",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            esenncial.belleza.bienestar@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
